<template>
    <div>
        <div class="split-fields">
            <txt id="first_name" v-model="model.first_name" label="first_name"></txt>
            <txt id="last_name" v-model="model.last_name" label="last_name"></txt>
        </div>
        <div class="split-fields">
            <txt id="org" v-model="model.org" label="organisation"></txt>
            <txt id="email" v-model="model.email" label="email"></txt>
        </div>
        <div class="split-fields">
            <txt id="phone" v-model="model.phone" label="phone"></txt>
            <txt id="fax" v-model="model.fax" label="fax"></txt>
        </div>
        <address-form :label="name" name="Domain" v-model="model.address"></address-form>
    </div>
</template>
<script>
    export default{
        props: {
            name: { default : '' }
        },
        created() {
            this.$eventHub.$on('setDomainContact', this.setDomainContact);
        },
        watch: {
            model: {
                handler: function (val, oldVal) {
                    this.$emit('input', this.model);
                },
                deep: true
            }
        },
        methods: {
            setDomainContact(data) {
                this.model = this.$setData(data, this.model);
            },
        },
        data: function() {
            return {
                model: {
                    address:{},
                    first_name: '',
                    last_name: '',
                    org: '',
                    email: '',
                    phone: '',
                    fax: '',
                }
            };
        },
        components: {
            'address-form': require('../view/address-form.vue').default,
            'txt': require('./form/text.vue').default
        }
    }
</script>
